import { defineStore } from "pinia";

interface State {
    versionData: VersionData | null; 

    activeLanguage: string;
    languages: string[];

    tutorialVisible: boolean;
    firstTimeTutorial: boolean;
    activeTutorialPage: number;

    availableSegments: ShowroomConfig["availableSegments"] | null; 
    waterEnabled: boolean;
    sewageEnabled: boolean;
    gasEnabled: boolean;

    isInfoPanelOpen: boolean;

    isTooltipOpen: boolean;
    tooltipData: TooltipData | null; 
    toolTipsDisabled: boolean;

    products: Product[]
    selectedProduct: Product | null;

    activeAreaID: number | null;

    isGround1Open: boolean;
    isGround2Open: boolean;
    loadingscreenVisible: boolean;
    defaultCamStats: DefaultCamStats;

    isMobile: boolean;
}

export const useStore = defineStore("main", {
    // State: Arrow Function, die den initialen State zurückgibt
    state: (): State => ({
        versionData: null,
        activeLanguage: 'de',
        languages: ['de'],
        tutorialVisible: false,
        firstTimeTutorial: true,
        activeTutorialPage: 0,
        availableSegments: null,
        waterEnabled: true,
        sewageEnabled: true,
        gasEnabled: true,
        isInfoPanelOpen: false,
        selectedProduct: null,
        isTooltipOpen: false,
        tooltipData: null,
        toolTipsDisabled: true,
        products: [],
        activeAreaID: null,
        isGround1Open: false,
        isGround2Open: false,
        loadingscreenVisible: true,
        isMobile: false,
        defaultCamStats: {
            radius: {
                upperLimit: null,
                lowerLimit: null,
                value: null,
            },
            alpha: {
                upperLimit: null,
                lowerLimit: null,
                value: null,
            },
            beta: {
                upperLimit: null,
                lowerLimit: null,
                value: null,
            },
            target: {
                x: 0,
                y: 0,
                z: 0,
            },
        }
    }),

    // Getters: In Pinia oft optional, da man direkt auf den State zugreifen kann.
    // Ich habe hier Getter definiert, um Alias-Namen aus dem alten Vuex-Store beizubehalten (z.B. isWaterEnabled vs waterEnabled).
    getters: {
        isWaterEnabled: (state) => state.waterEnabled,
        isSewageEnabled: (state) => state.sewageEnabled,
        isGasEnabled: (state) => state.gasEnabled,
        isTutorialVisible: (state) => state.tutorialVisible,
        isFirstTimeTutorial: (state) => state.firstTimeTutorial,
        // Für Properties, die im State gleich heißen wie im Getter, brauchst du in Pinia eigentlich keinen Getter,
        // aber für Typsicherheit oder Readonly-Access kann man sie behalten.
    },

    // Actions: Ersetzen Mutations. Können direkt 'this' verwenden.
    actions: {
        setVersionData(data: VersionData) {
            this.versionData = data;
        },
        setToolTipsDisabled(boolean: boolean) {
            console.log((boolean ? "Disable" : "Enable") + " Tooltips");
            this.toolTipsDisabled = boolean;
        },
        setLoadingscreenVisible(boolean: boolean) {
            this.loadingscreenVisible = boolean;
        },
        setActiveLanguage(code: string) {
            this.activeLanguage = code;
        },
        setProducts(array: Product[]) {
            this.products = array;
        },
        setLanguages(array: string[]) {
            this.languages = array;
        },
        setAvailableSegments(object: ShowroomConfig["availableSegments"]) {
            this.availableSegments = object;
        },
        setWaterBool(boolean: boolean) {
            this.waterEnabled = boolean;
        },
        setSewageBool(boolean: boolean) {
            this.sewageEnabled = boolean;
        },
        setGasBool(boolean: boolean) {
            this.gasEnabled = boolean;
        },
        setActiveAreaID(id: number | null) {
            this.activeAreaID = id;
        },
        toggleWaterBool() {
            this.waterEnabled = !this.waterEnabled;
        },
        toggleSewageBool() {
            this.sewageEnabled = !this.sewageEnabled;
        },
        toggleGasBool() {
            this.gasEnabled = !this.gasEnabled;
        },
        setDefaultCamStats(camStats: DefaultCamStats) {
            this.defaultCamStats = camStats;
        },
        setInfoPanelOpen(boolean: boolean) {
            this.isInfoPanelOpen = boolean;
        },
        setTooltipOpen(boolean: boolean) {
            this.isTooltipOpen = boolean;
        },
        setTooltipData(data: TooltipData | null) {
            this.tooltipData = data;
        },
        setSelectedProduct(data: Product | null) {
            this.selectedProduct = data;
        },
        setTutorialVisible(boolean: boolean) {
            console.log((boolean ? "Show" : "Hide") + " Tutorial");
            this.tutorialVisible = boolean;
        },
        setFirstTimeTutorial(boolean: boolean) {
            this.firstTimeTutorial = boolean;
        },
        setIsMobile(boolean: boolean) {
            this.isMobile = boolean;
        }
    }
});